import styled, { css, keyframes } from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, REDUCED_MOTION, SPACE, STORYBOARD_COMPOSE } from '@/nova/theme/tokens';

/* A hard on/off caret blink while a phrase rests; steady while characters are moving. */
const caretBlink = keyframes`
  0%, 46% { opacity: 1; }
  50%, 96% { opacity: 0; }
  100% { opacity: 1; }
`;



/* The morphing mark's slot. Its strands flourish blooms past the slot (overflow visible), so a little side
   margin keeps the bloom mostly in the gap rather than over the first letters. */
export const Mark = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  margin: 0 ${STORYBOARD_COMPOSE.STATUS_MARK_BLOOM_PX}px;
`;

export const Words = styled.span`
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** One line: pulsing mark, the typed phrase with its caret, then the static model label. Never wraps; a
 *  long phrase ellipsises so the Stop button beside it keeps its place. `$stacked`: the mark above the words, both
 *  centred, so the mark stays put while the phrase types (the words keep to one line, so nothing shifts vertically). */
export const Line = styled.span<{ $stacked: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  font-size: 13px;
  color: ${COLORS.textMuted};

  ${({ $stacked }) =>
    $stacked &&
    css`
      flex-direction: column;
      gap: ${SPACE[8]};
      max-width: 100%;
      text-align: center;

      ${Words} {
        max-width: 100%;
      }
    `}
`;

export const Phrase = styled(Text).attrs({ tag: 'span' as const })`
  color: inherit;
`;

export const Caret = styled.span<{ $busy: boolean }>`
  display: inline-block;
  width: 1.5px;
  height: 1em;
  margin-left: 2px;
  vertical-align: -0.14em;
  background: currentColor;
  animation: ${caretBlink} ${STORYBOARD_COMPOSE.STATUS_CARET_BLINK_MS}ms steps(1, end) infinite;
  ${(p) => (p.$busy ? 'animation: none; opacity: 1;' : '')}

  ${REDUCED_MOTION} {
    display: none;
  }
`;

export const Suffix = styled.span`
  flex: 0 0 auto;
  white-space: nowrap;
  color: ${COLORS.textFaint};
`;
